<template>
<v-list dense three-line subheader class='pa-0'>
  <v-subheader v-if='title' >
    <v-btn small icon @click='fetch' ><v-icon small>replay</v-icon></v-btn>
    <span class='ml-3 overline' >{{title}}</span>
    <v-spacer></v-spacer>
    <v-text-field v-model='searchString' dense placeholder='search' append-icon='search' ></v-text-field>
  </v-subheader>
  <v-divider></v-divider>
  <!-- v-if='template.is_active && template.allow_ad_hoc_sending' -->
  <template v-for='template in filteredTemplates' >
    <v-list-tile
      :key='template.id'
      @click='$emit("selected", template)' >
      <v-list-tile-action v-if='showNew' >
        <v-btn @click.stop='$emit("selected", template)' icon ><v-icon>edit</v-icon></v-btn>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{template.ui_action_name || template.name}}
          <v-chip
            v-if='template.owner != "0"'
            class='v-chip--x-small' color='primary' x-small outline outlined >custom</v-chip>
        </v-list-tile-title>
        <v-list-tile-sub-title>{{template.description}}</v-list-tile-sub-title>
        <v-list-tile-sub-title>
          <v-chip  class='v-chip--x-small' v-if='template.is_active' color='success' dark >
            <v-icon small class='mr-1' >check</v-icon>
            Active
          </v-chip>
          <v-chip outline class='v-chip--x-small' v-if='template.shared' >
            Shared
          </v-chip>
          <v-chip class='v-chip--x-small' v-for= 'category in template.categories' :key='category.id' >
            {{category.name}}
          </v-chip>
          <space-faces
            v-if='template.spaces && template.spaces.length > 0'
            :space-ids='template.spaces' >
          </space-faces>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider :key='`div-${template.id}`' ></v-divider>
  </template>
  <v-btn v-if='showNew' @click='$emit("new", null)' flat text block >
    <v-icon>add</v-icon>
    Create a new template
  </v-btn>
</v-list>
</template>
<script>
import SpaceFaces from '@/components/lists/SpaceFaces'

export default {
  name: 'CommunicationTemplateList',
  props: {
    title: { type: String, required: false },
    context: { type: String, required: false }
  },
  components: { SpaceFaces },
  data () {
    return {
      searchString: '',
      reqId: 'get-communication-templates'
    }
  },
  mounted () {
    this.fetch()
  },
  computed: {
    showNew () {
      let userId = this.getObjectPath(this.$store.getters.me, 'profile.user')
      return [1, 125, 412].indexOf(userId) >= 0
    },
    request () {
      return this.$store.getters.getRequestById(this.reqId)
    },
    templates () {
      return this.getObjectPath(this.request, 'result.data.results', [])
    },
    filteredTemplates () {
      let items = this.templates
      if (this.context) {
        items = this.templates.filter((item) => {
          let categories = item.categories
          if (categories && categories.length > 0) {
            return categories.find((cat) => {
              // console.log(cat.name, this.context)
              let match = cat.name === this.context
              if (match) { return cat }
            })
          }
        })
      }
      if (this.searchString && this.searchString.length > 0) {
        items = items.filter((item) => {
          return item.name.toLowerCase().indexOf(this.searchString.toLowerCase()) >= 0
        })
      }
      return items
    }
  },
  methods: {
    fetch () {
      let params = {}
      if (this.context) {
        params['category'] = this.context
      }
      this.$communicationguru
          .resource('template')
          .id(this.reqId)
          .list(this.params)
      this.$communicationguru
        .resource('template.context')
        .id(this.reqId + '-context')
        .list()
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Message templates'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CommunicationTemplateList.vue?41e7ff74